module.exports = __webpack_public_path__ + "img/gb9877_1-88-70x95x10.prt.b7440c21.jpg";